import dayjs from "dayjs";
import { atom, DefaultValue, selectorFamily } from "recoil";
import { ICompany, IGetCarsAvailabilitiesParams, IRangeDate } from "../../api/services";
import { AccordionsExpanded, InsertBookingStep } from "./types";

export const stepState = atom<InsertBookingStep | null>({
    key: 'stepState',
    default: InsertBookingStep.AVAILABILITY_PRICE,
});

export const accordionsExpandedState = atom<AccordionsExpanded>({
    key: 'accordionsExpandedState',
    default: {
        extraServices: false,
        total: true,
        bookingOwner: false,
        invoice: false,
        firstDriver: false,
        additionalDrivers: false,
        billingAddress: false
    },
});

export const accordionExpandedState = selectorFamily<boolean, keyof AccordionsExpanded>({
    key: 'accordionExpandedState',
    get: accordionName => ({ get }) => get(accordionsExpandedState)[accordionName],
    set: accordionName => ({ get, set }, newValue) => {
        set(accordionsExpandedState, {
            ...get(accordionsExpandedState),
            [accordionName]: newValue instanceof DefaultValue ? false : newValue
        })
    }
});

export const totalRentalDaysState = atom<number>({
    key: 'totalRentalDaysState',
    default: 0
});

export const carsAvailabilitiesParamsState = atom<IGetCarsAvailabilitiesParams | undefined>({
    key: 'carsAvailabilitiesParamsState',
    default: undefined
});

export const bookingIdState = atom<string | undefined>({
    key: 'bookingIdState',
    default: undefined
});

export const expirationDateTimeState = atom<dayjs.Dayjs | null>({
    key: 'expirationDateTimeState',
    default: null
});

export const requestUpdateTimeState = atom<string | null>({
    key: 'requestUpdateTimeState',
    default: undefined
});

export const idSmProductDefaultByDraftState = atom<string | null>({
    key: 'idSmProductDefaultByDraftState',
    default: undefined
});

export const businessAgreementCheckValidate = atom<boolean | undefined>({
    key: 'businessAgreementCheckValidate',
    default: undefined
});

export const businessAgreementCig = atom<boolean | undefined>({
    key: 'businessAgreementCig',
    default: undefined
});

export const mandatoryDossierIsRequired = atom<boolean | undefined>({
    key: 'mandatoryDossierIsRequired',
    default: undefined
});

export const rangeDateValidity = atom<IRangeDate | undefined>({
    key: 'rangeDateValidity',
    default: undefined
});

export const customerBillingDataB2B = atom<ICompany | undefined>({
    key: 'customerBillingDataB2B',
    default: undefined
});

export const isLeisureCode = atom<boolean>({
    key: 'isLeisureCode',
    default: false
});

export const isBusinessContinuityMode = atom<boolean>({
    key: 'isBusinessContinuityMode',
    default: undefined
});

export const ratePlanOfferIDState = atom<string | undefined>({
    key: 'ratePlanOfferIDState',
    default: undefined
});

export const codeDescriptionState = atom<string | undefined>({
    key: 'codeDescriptionState',
    default: undefined
});

export const isPersonBAState = atom<boolean>({
    key: 'isPersonBAState',
    default: false
});

export const isOfferState = atom<boolean>({
    key: 'isOfferState',
    default: false
});

export const isSelectedCarGroupUnavailableState = atom<boolean>({
    key: 'isSelectedCarGroupUnavailableState',
    default: false
});
